<template>
  <div :class="{ 'learning-unit': true, 'dark-mode': $store.state.isDarkMode }">
    <EachHeader :key="loadFlg" :title="$store.state.subject" />
    <SideMenuArea :key="loadFlg" class="col-left" />
    <ContentsListArea :key="loadFlg" class="col-right" />
  </div>
</template>

<script>
import { onMounted, provide, ref, computed, watch } from "vue";
import { useRoute } from "vue-router";
import EachHeader from "../components/EachHeader.vue";
import SideMenuArea from "@/layouts/SideMenuArea.vue";
import ContentsListArea from "@/layouts/ContentsListArea.vue";

export default {
  name: "LearningUnit",
  components: {
    EachHeader,
    SideMenuArea,
    ContentsListArea,
  },
  props: {
    unitTitle: { type: String, default: "" },
    learningUnitJson: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const route = useRoute();
    const learningUnitJson = ref(props.learningUnitJson);
    const unitTitle = ref(props.unitTitle);
    const loadFlg = ref(0);
    // const unitTitle = ref(removeHtmlTag(props.unitTitle));

    // console.log(
    //   `path:${route.path}, hash:${route.hash}, mode:${route.query.mode}`
    // );
    // console.log(props.learningUnitJson);

    const updateLearningUnitJson = () => {
      learningUnitJson.value = props.learningUnitJson;
    };

    const updateUnitTitle = () => {
      unitTitle.value = props.unitTitle;
    };

    provide("updateLearningUnitJson", updateLearningUnitJson);
    provide("learningUnitJson", learningUnitJson);
    // provide("learningUnitJson", learningUnitJson.value);
    provide("currentUnit", unitTitle);

    const loadForce = () => {
      loadFlg.value = !loadFlg.value;
    };

    const prop = computed(() => props.learningUnitJson);
    watch(prop, () => {
      updateLearningUnitJson();
      updateUnitTitle();
      loadForce();
    });

    const scrollTo = (elem, top) => {
      elem.scrollTop = top;
    };

    onMounted(() => {
      // console.log(route.hash);

      if (route.hash) {
        document.getElementsByClassName("select")[0].scrollIntoView({
          behavior: "instant",
          block: "start",
          inline: "center",
        });
        const targetId = route.hash.replace("#", "");
        const targetElem = document.getElementById(targetId);

        if (!targetElem) return;

        const targetTop = targetElem.getBoundingClientRect().top;
        const contentList = document.querySelector(".contents-list");
        const eachHeaderHeight = document
          .querySelector(".each-header")
          .getBoundingClientRect().height;

        setTimeout(
          () => scrollTo(contentList, targetTop - eachHeaderHeight),
          1
        );

        const contentsListContainer = document.querySelector(
          ".contents-list-container"
        );

        const containerHeight =
          contentsListContainer.getBoundingClientRect().height;
        
        const colRightTop = 50;
        const defaultBottom = 60;
        const offsetBottom =
          window.innerHeight - containerHeight - eachHeaderHeight + targetTop + defaultBottom + colRightTop;

        if (offsetBottom > defaultBottom) {
          contentsListContainer.style.paddingBottom = offsetBottom + "px";
        }
      }
    });
    return {
      loadFlg,
    };
  },
};
</script>

<style scoped lang="stylus">
.learning-unit
  background-color var(--light-skyblue)
  height 100%
  overflow hidden
  position relative
  transition all .5s ease-out;
  &.dark-mode
    background-color var(--dark-midnightblue)
    transition all .5s ease-out;

.col-left
  position fixed
  top 60px
  left 0
  width 30%
  height 100%
  overflow auto

.col-right
  position fixed
  top 50px
  right 0
  // padding-top 60px
  width 70%
  height 100%
  overflow auto
</style>
